import React, { useState, useEffect } from "react";
export default function Purchases() {
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  
  const [form, setForm] = useState({ 
    vendor_name: "", 
    date: new Date().toISOString().split('T')[0], 
    base_amount: "", 
    gst_rate: 18 
  });

  const loadData = () => fetch('/api/purchases').then(r=>r.json()).then(d=>setData(Array.isArray(d)?d:[]));
  useEffect(() => { loadData(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const base = Number(form.base_amount);
    const rate = Number(form.gst_rate);
    const gstAmt = base * (rate / 100);
    const total = base + gstAmt;

    const payload = {
        vendor_name: form.vendor_name,
        date: form.date,
        base_amount: base,
        gst_rate: rate,
        gst_amount: gstAmt,
        total_amount: total
    };

    const url = editId ? `/api/purchases/${editId}` : '/api/purchases';
    const method = editId ? 'PUT' : 'POST';

    await fetch(url, { 
        method, 
        headers: {'Content-Type': 'application/json'}, 
        body: JSON.stringify(payload) 
    });
    
    setShowForm(false);
    setEditId(null);
    setForm({ vendor_name: "", date: new Date().toISOString().split('T')[0], base_amount: "", gst_rate: 18 });
    loadData();
  };

  const handleEdit = (p) => {
    // Pichla entry edit karne ke liye data load karna
    setForm({
      vendor_name: p.vendor_name || p.supplier || "",
      date: p.date || p.created_at || new Date().toISOString().split('T')[0],
      base_amount: p.base_amount || (Number(p.total_amount) - Number(p.gst_amount || 0)) || "",
      gst_rate: p.gst_rate || 18
    });
    setEditId(p.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if(window.confirm("Kya aap is purchase entry ko sach mein delete karna chahte hain?")) {
      await fetch(`/api/purchases/${id}`, { method: 'DELETE' });
      loadData();
    }
  };

  // Live Auto-Calculation dikhane ke liye
  const calcBase = Number(form.base_amount || 0);
  const calcRate = Number(form.gst_rate || 0);
  const calcGst = calcBase * (calcRate / 100);
  const calcTotal = calcBase + calcGst;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">GST Purchases & Expenses</h1>
        <button onClick={() => {setShowForm(true); setEditId(null); setForm({ vendor_name: "", date: new Date().toISOString().split('T')[0], base_amount: "", gst_rate: 18 });}} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow">
          + Add Purchase
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-blue-50 p-6 rounded-lg shadow-md mb-6 relative border-t-4 border-blue-600">
          <button type="button" onClick={()=>setShowForm(false)} className="absolute top-2 right-4 text-red-500 font-bold hover:underline">✕ Close</button>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-start">
            <div className="col-span-2 md:col-span-2">
              <label className="block text-sm font-bold mb-1 text-gray-700">Vendor / Party Name</label>
              <input required className="w-full border-2 border-gray-300 p-2 rounded font-bold focus:border-blue-500" value={form.vendor_name} onChange={e=>setForm({...form, vendor_name: e.target.value})} />
            </div>
            <div>
              <label className="block text-sm font-bold mb-1 text-gray-700">Date</label>
              <input required type="date" className="w-full border-2 border-gray-300 p-2 rounded font-bold cursor-pointer focus:border-blue-500" value={form.date} onChange={e=>setForm({...form, date: e.target.value})} />
            </div>
            
            <div className="col-span-2 md:col-span-4 border-t border-gray-200 mt-2 pt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
               <div>
                 <label className="block text-sm font-bold mb-1 text-gray-700">Base Amount (₹)</label>
                 <input required type="number" placeholder="Without Tax" className="w-full border-2 border-gray-300 p-2 rounded font-bold focus:border-blue-500" value={form.base_amount} onChange={e=>setForm({...form, base_amount: e.target.value})} />
               </div>
               <div>
                 <label className="block text-sm font-bold mb-1 text-gray-700">GST %</label>
                 <select className="w-full border-2 border-gray-300 p-2 rounded font-bold focus:border-blue-500" value={form.gst_rate} onChange={e=>setForm({...form, gst_rate: e.target.value})}>
                    <option value="0">0%</option>
                    <option value="5">5%</option>
                    <option value="12">12%</option>
                    <option value="18">18%</option>
                    <option value="28">28%</option>
                 </select>
               </div>
               <div className="bg-yellow-100 p-2 rounded border border-yellow-300 text-center">
                  <label className="block text-xs font-bold mb-1 text-yellow-800">GST Input (Auto)</label>
                  <div className="text-lg font-extrabold text-yellow-700">₹{calcGst.toFixed(2)}</div>
               </div>
               <div className="bg-green-100 p-2 rounded border border-green-300 text-center">
                  <label className="block text-xs font-bold mb-1 text-green-800">Total Bill Amount (Auto)</label>
                  <div className="text-lg font-extrabold text-green-700">₹{calcTotal.toFixed(2)}</div>
               </div>
            </div>

            <button type="submit" className="bg-blue-600 text-white px-6 py-3 rounded font-bold col-span-2 md:col-span-4 text-lg hover:bg-blue-700 mt-2">
               {editId ? "Update Purchase Entry" : "Save Purchase Entry"}
            </button>
          </div>
        </form>
      )}

      <div className="bg-white shadow rounded-lg p-4 overflow-x-auto">
        <table className="min-w-full text-left">
          <thead>
            <tr className="border-b-2 text-gray-500 uppercase text-sm">
                <th className="pb-3 p-2">Date</th><th className="pb-3 p-2">Vendor</th><th className="pb-3 p-2 text-right">Base Amt</th><th className="pb-3 p-2 text-right">GST Input</th><th className="pb-3 p-2 text-right">Total Amount</th><th className="pb-3 p-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && <tr><td colSpan="6" className="text-center p-4 text-gray-500">No purchase records found.</td></tr>}
            {data.map((p,i) => (
              <tr key={i} className="border-b hover:bg-gray-50">
                  <td className="py-3 p-2 text-gray-600 font-medium">{p.date || p.created_at}</td>
                  <td className="p-2 font-bold text-blue-800">{p.vendor_name || p.supplier}</td>
                  <td className="p-2 text-right text-gray-600">₹{Number(p.base_amount || (Number(p.total_amount) - Number(p.gst_amount || 0))).toFixed(2)}</td>
                  <td className="p-2 text-right text-orange-600 font-bold">₹{Number(p.gst_amount || 0).toFixed(2)} <span className="text-xs text-gray-400">({p.gst_rate||18}%)</span></td>
                  <td className="p-2 text-right font-bold text-gray-900 text-lg">₹{Number(p.total_amount || p.amount || 0).toFixed(2)}</td>
                  <td className="p-2 text-center whitespace-nowrap">
                    <button onClick={()=>handleEdit(p)} className="bg-blue-100 text-blue-700 px-3 py-1 rounded text-xs font-bold mr-2 hover:bg-blue-200">Edit</button>
                    <button onClick={()=>handleDelete(p.id)} className="bg-red-100 text-red-700 px-3 py-1 rounded text-xs font-bold hover:bg-red-200">Del</button>
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
